import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/workspace/internal')({
  beforeLoad: () => {
    throw redirect({ to: '/scraping' });
  },
});
